var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{staticClass:"space-img",attrs:{"src":require("@/assets/images/SPRINT_GAMING_PNG.png")}}),_c('div',{staticClass:"text-light"},[_vm._v("© copyright")])])
}]

export { render, staticRenderFns }